import { Column, Entity, Unique } from 'typeorm';
import { BaseEntity } from './base.entity';

@Entity('client_location_count_county')
@Unique('uq_client_loc_count_county_state', ['county', 'state'])
export class ClientLocationCountCountyEntity extends BaseEntity {
	@Column('varchar', { name: 'county', length: 255 })
	public county!: string;

	@Column('varchar', { name: 'state', length: 10 })
	public state!: string;

	@Column('int', { name: 'client_count', unsigned: true, default: 0 })
	public clientCount!: number;
}
